import styled from "styled-components";

const StyledPassportForm = styled.div`
  display: grid;
  grid-auto-rows: auto;
  gap: 24px;

  form {
    display: grid;
    grid-auto-rows: auto;
    gap: 24px;
  }
`;

export default StyledPassportForm;
